/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

riot.mixin('unitConversion', {
	convert: function(value, opts) {
		var Big = window.Big;
		opts = opts || {};
		var startingValue = new Big(value);
		var normalizedValue = new Big(0);
		var stringValue = '';
		var stringArray = [];
		var resolution = opts.resolution || 72;
		var pointsPerInch = opts.pointsPerInch || 72;
		var picasPerInch = opts.picasPerInch || 72;
		var trim = opts.trim !== false;
		var precision = opts.precision || 5;

		resolution = new Big(resolution);
		pointsPerInch = new Big(pointsPerInch);
		picasPerInch = new Big(picasPerInch);

		var conversionTable = {
			m: {
				factor: new Big(1)
			},
			cm: {
				factor: new Big(0.01)
			},
			in: {
				factor: new Big(0.0254)
			},
			mm: {
				factor: new Big(0.001)
			},
			px: {
				factor: new Big(0.0254).div(resolution)
			},
			pt: {
				factor: new Big(0.0254).div(pointsPerInch)
			},
			pc: {
				factor: new Big(0.0254).div(picasPerInch)
			},
			ha: {
				factor: new Big(0.0254).div(101.6)
			},
			c: {
				factor: new Big(0.0254*0.177609377775)
			},
			ag: {
				factor: new Big(0.0254).div(14.0)
			},
			cu: {
				factor: new Big(0.0254*19.0512)
			},
			ft: {
				factor: new Big(0.3048)
			},
			ftin: {
				factor: new Big(0.9144)	
			},
			yd: {
				factor: new Big(0.9144)	
			}
		};

		return {
			from: function(value) {
				normalizedValue = startingValue.mul(conversionTable[value].factor);
				return this;
			},
			to: function(value) {
				stringValue = normalizedValue.div(conversionTable[value].factor).toFixed(10);

				if (trim) {
					stringArray = stringValue.split('.');
					// if decimal
					if (stringArray[1]) {
						stringArray[1] = stringArray[1].substring(0, precision);
					}
					stringValue = stringArray.join('.');
				}

				return Number(stringValue);
			}
		};
	}
});
